'use strict';

export default {
  library: {
    dateRangeField: {
      action: {
        hide: 'Hide',
        show: 'Show',
      },
    },
    productsField: {
      product: 'Produit',
      quantity: 'Qté',
      price: 'Prix',
      subtotal: 'Sous-total',
    },
  },
};
